import React from 'react';
import {
  Labeled,
  TextField,
  SelectField,
} from 'react-admin';
import '../styles.css';

import { trustedContactRelationship } from '../../../helpers/mappings';
import { formatString } from '../../../helpers/utils';

export default ({ record }) => (
  <table style={{ width: '100%' }}>
    <tbody>
      <tr>
        <td style={{ width: '50%' }}>
          <Labeled label="First Name">
            <TextField source="trustedContact.firstName" record={record} />
          </Labeled>
        </td>
        <td style={{ width: '50%' }}>
          <Labeled label="Last Name">
            <TextField source="trustedContact.lastName" record={record} />
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Email">
            <TextField source="trustedContact.email" record={record} />
          </Labeled>
        </td>
        <td>
          <Labeled label="Telephone">
            {record.trustedContact.telephone ? <span className="normalField">{formatString(record.trustedContact.telephone, '(###) ###-####')}</span> : <span className="normalField">N/A</span>}
          </Labeled>
        </td>
      </tr>
      <tr>
        <td>
          <Labeled label="Relationship">
            <SelectField source="trustedContact.relationship" choices={trustedContactRelationship} record={record} />
          </Labeled>
        </td>
      </tr>
    </tbody>
  </table>
);



// WEBPACK FOOTER //
// ./src/components/User/children/TrustedContact_Show.jsx